<ion-content [ngClass]="{'footer-block': isSaveList}">
  <ion-header>
    <app-header></app-header>
  </ion-header>
  <div class="page-width-and-shadow">
    <div class="details-wrap">
      <div class="top-box">
        <div class="button" [@enter] [@leave]>
          <img *ngIf="data !== null && prevDelegateId > 0" src="assets/img/left-grey.svg" (click)="prevTeamMember()"
               alt="#">
        </div>
        <div class="text" [@enter] [@leave]>
          <img *ngIf="data !== null && !!data.delegate.avatar" class="avatar" [src]="data.delegate.avatar.url">
          <app-inline-svg *ngIf="data === null || !data.delegate.avatar"
                          [file]="'assets/img/user-blue.svg'"></app-inline-svg>
          <span *ngIf="data !== null">{{ data.delegate.full_name }}</span>
          <span *ngIf="data === null"><ion-skeleton-text animated></ion-skeleton-text></span>
        </div>
        <div class="button" [@enter] [@leave]>
          <img *ngIf="data !== null && nextDelegateId > 0" src="assets/img/right-grey.svg" (click)="nextTeamMember()"
               alt="#">
        </div>
      </div>
    </div>

    <ng-container *ngIf="data !== null">
      <ng-container *ngFor="let journey of data.journeys">
        <div *ngIf="false" class="header-wrap content-wrap-inner compact">
          <h2>{{ "__TEAM_JOURNEY__" | translate }}: {{ journey.journey.name }}</h2>
        </div>
        <ng-container *ngFor="let stage of journey.stages">
          <div class="header-wrap content-wrap-inner compact">
            <h2>{{ "__TEAM_JOURNEY__" | translate }}: {{ journey.journey.name }}</h2>
            <h3>{{ "__TEAM_STAGE__" | translate }}: <span class="my-color-blue">{{ stage.info.title }}</span></h3>
          </div>

          <div class="program-wrap" *ngIf="stage.info.type === 'program'">
            <app-journey-list-template-course-title
              [programDelegate]="stage.details.program_delegate"></app-journey-list-template-course-title>
          </div>
          <div class="list-wrap" *ngIf="stage.info.type === 'list' && stage.details.tasks.length">
            <!--div class="line-text content-wrap-inner" *ngIf="stage.details.tasks.length" [@enter] [innerHTML]="('__TEAM_DETAILS_DESC1__' | translate)"></div-->
            <div class="list">
              <ng-container *ngFor="let item of stage.details.tasks; let i = index">
                <ng-container *ngIf="item.section !== 'course_title' && !(item.section === 'webinar' && !!item.interactions && item.interactions.length > 0)">
                  <div class="line line-empty content-wrap-inner compact"
                       *ngIf="false && item.section !== 'course_title' && i===0"></div>
                  <div class="line" [ngClass]="{'content-wrap-inner compact': item.section !== 'course_title'}"
                       [@leave]>
                    <app-journey-list-template-checkbox
                      *ngIf="['custom_textbox', 'roi', 'course_title', 'html', 'custom_feedback'].indexOf(item.section) < 0 && !item.for_manager"
                      [ngClass]="{disabled: item.section !== 'file' || !item.details.file.url }" [disabled]="true"
                      [task]="item" [for_manager]="true"></app-journey-list-template-checkbox>

                    <app-journey-list-template-checkbox
                      *ngIf="['custom_textbox', 'html', 'custom_feedback'].indexOf(item.section) < 0 && item.for_manager"
                      [task]="item" [for_manager]="true"></app-journey-list-template-checkbox>

                    <app-journey-list-template-feedback-list
                      *ngIf="item.section === 'custom_feedback' && (!item.url || ['select', 'multiselect', 'progress'].indexOf(item.url) < 0)"
                      [task]="item" [for_manager]="true" [disabled]="!item.for_manager"
                      (doChange)="onFormChange($event)"></app-journey-list-template-feedback-list>
                    <app-journey-list-template-feedback-multiselect
                      *ngIf="item.section === 'custom_feedback' && ['select', 'multiselect'].indexOf(item.url) >= 0"
                      [task]="item" [isMultiselect]="item.url === 'multiselect'" [for_manager]="true"
                      [disabled]="!item.for_manager"
                      (doChange)="onFormChange($event)"></app-journey-list-template-feedback-multiselect>
                    <app-journey-list-template-feedback-progress
                      *ngIf="item.section === 'custom_feedback' && item.url === 'progress'"
                      [task]="item" [for_manager]="true" [disabled]="!item.for_manager"
                      (doChange)="onFormChange($event)"></app-journey-list-template-feedback-progress>

                    <app-list-dropdown *ngIf="item.section === 'custom_textbox' && !item.for_manager"
                                       [title]="item.title_for_manager ?? item.title">
                      <app-journey-list-template-textarea
                        [task]="item" [readonly]="true" [embedded]="true"
                        [for_manager]="true"></app-journey-list-template-textarea>
                    </app-list-dropdown>

                    <app-journey-list-template-textarea
                      *ngIf="item.section === 'custom_textbox' && item.for_manager"
                      [task]="item" [for_manager]="true" [embedded]="true"
                      (doChange)="onFormChange($event)"></app-journey-list-template-textarea>

                    <app-list-dropdown *ngIf="item.section === 'roi' && !item.for_manager"
                                       [title]="item.title_for_manager ?? item.title">
                      <app-journey-list-template-financial
                        [task]="item" [readonly]="true" [embedded]="true"
                        [for_manager]="true"></app-journey-list-template-financial>
                    </app-list-dropdown>

                    <app-journey-list-template-course-title *ngIf="item.section === 'course_title'"
                                                            [programDelegate]="item.details.program_delegate"
                                                            [for_manager]="true"></app-journey-list-template-course-title>

                    <app-journey-list-template-html *ngIf="item.section === 'html'"
                                                    [disabled]="!item.for_manager"
                                                    [task]="item" [title]="item.title_for_manager ?? item.title"
                                                    [html]="item.text_for_manager ?? item.text"></app-journey-list-template-html>

                  </div>
                  <!--div class="line-text content-wrap-inner" *ngIf="item.section === 'course_title' && stage.details.tasks.length > i + 1" [@enter] [innerHTML]="('__TEAM_DETAILS_DESC1__' | translate)"></div-->
                  <div class="line line-empty content-wrap-inner compact" *ngIf="item.section === 'course_title'"></div>
                </ng-container>

                <ng-container *ngIf="item.section === 'webinar' && !!item.interactions && item.interactions.length > 0">
                <app-journey-list-template-interaction
                  *ngFor="let interaction of item.interactions"
                  [interactionId]="interaction.interactionId"
                  [userId]="interaction.userId">
                </app-journey-list-template-interaction>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>


    <!--<div class="list-wrap" *ngIf="data !== null">-->
    <!--    <div class="line-text content-wrap-inner" *ngIf="data.tasks.length > 0" [@enter] [innerHTML]="('__TEAM_DETAILS_DESC2__' | translate)"></div>-->
    <!--    <div class="list " *ngIf="data.tasks.length > 0">-->
    <!--        <div *ngFor="let item of data.tasks ; let i = index" class="line content-wrap-inner"-->
    <!--             [@leave]>-->
    <!--            <app-journey-list-template-checkbox-->
    <!--                    *ngIf="item.section !== 'custom_textbox'"-->
    <!--                    [task]="item"></app-journey-list-template-checkbox>-->

    <!--            <app-journey-list-template-textarea-->
    <!--                    *ngIf="item.section === 'custom_textbox'"-->
    <!--                    [task]="item" [embedded]="true"-->
    <!--                    (doChange)="onFormChange($event)"></app-journey-list-template-textarea>-->
    <!--        </div>-->
    <!--    </div>-->
    <!--</div>-->

    <div class="list-wrap" *ngIf="data === null">
      <div class="line-text content-wrap-inner compact">
        <ion-skeleton-text animated style="width: 80%; height: 1.5rem"></ion-skeleton-text>
      </div>
      <div class="list content-wrap-inner compact" style="border-top: none">
        <app-skeleton-tasks></app-skeleton-tasks>
      </div>
    </div>
  </div>
</ion-content>
<ion-footer *ngIf="isSaveList" class="swiper-no-swiping">
  <app-footer (saveEvent)="onSaveList()" [backButton]="true" [saveButton]="true"></app-footer>
</ion-footer>
